// EditorView is the page structure for the editor.

import EditorHeader from 'app/src/editor/EditorHeader';
import EditorMap from 'app/src/editor/EditorMap';
import EditorSidePanel from 'app/src/editor/EditorSidePanel';
import * as React from 'react';

export default function EditorView(): React.ReactElement {
	return (
		<div className="Editor">
			<div className="Editor-sidePanelContainer">
				<EditorSidePanel />
			</div>
			<div className="Editor-mainPanel">
				<div className="Editor-headerContainer">
					<EditorHeader />
				</div>
				<div className="Editor-mapContainer">
					<EditorMap />
				</div>
			</div>
		</div>
	);
}
